// Devuelve las props para abrir en pestaña nueva los enlaces de menú que toca
// (de momento, Catálogos: su URL de Libra contiene "catalog").
export function propsNuevaPestana(programa) {
  return typeof programa === 'string' && programa.toLowerCase().includes('catalog')
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {}
}
